import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Links from '../../links';
import Base from '../Base';


const EventLink = styled(Link)`
display: block;
  margin-left: 20px;
`;

function EventsTopBody() {
  return (
    <>
      <Base body={
        <>
          {
            Links.map((link, index) => (
              index === 0 ? null : (
                <EventLink key={index} to={link.url}>
                  {link.text}
                </EventLink>
              )
            ))
          }
        </>
      } title="プロスピA イベント" />
    </>
  );
}

export default EventsTopBody;
